import { Grid } from "@mui/material"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom"
import styles from "../../MenuImage/menuImage.module.scss"
import { FieldArray, Formik } from "formik"
import { validationSchemaMenuImage } from "helpers/validationSchema"
import { addWeeklyCategoryImageAction } from "redux/superAdmin/actions"
import { useDispatch, useSelector } from "react-redux"
import WeeklyCategoryImageForm from "./weeklyCategoryImageForm"

const EditWeeklyCategoryImage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [initialValues, setInitialValues] = useState({})
  const { weeklyCategory, menuImages } = useSelector((store) => store.superAdmin)

  const handleCancel = () => {
    history.goBack()
  }

  const handleSubmit = (values) => {
    const payload = {
      categories:
        values?.weeklyimage?.length === 0
          ? null
          : values?.weeklyimage?.map((el, index) => ({
              id: el?.id,
              name: el?.name,
              image: menuImages?.[index] ? menuImages?.[index] : el?.image ? el?.image?.id : null
            }))
    }

    const onClose = () => {
      history.replace("/super-admin/dashboard/weekly-category-image")
    }
    dispatch(addWeeklyCategoryImageAction({ payload: payload, onClose: onClose }))
  }

  const resetFormikData = () => {
    if (weeklyCategory?.length < 1) {
      setInitialValues({
        weeklyimage: [
          {
            name: "",
            image: null
          },
          {
            name: "",
            image: null
          },
          {
            name: "",
            image: null
          },
          {
            name: "",
            image: null
          }
        ]
      })
    } else {
      setInitialValues({
        weeklyimage: weeklyCategory?.map((el) => ({
          id: el.id,
          name: el.name,
          image: el.image_url
            ? {
                id: el?.image,
                url: el.image_url
              }
            : ""
        }))
      })
    }
  }

  useEffect(() => {
    resetFormikData()
  }, [weeklyCategory])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Edit Weekly Category Image"
  }, [])
  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationSchemaMenuImage}
        onSubmit={handleSubmit}>
        {(formik) => (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Header title="Menu Image" breadCrumbs={breadCrumbs}>
                  <AppButton onClick={handleCancel} className={styles.cancelButton}>
                    Cancel
                  </AppButton>
                  <AppButton onClick={formik.handleSubmit} className={styles.saveButton}>
                    Save
                  </AppButton>
                </Header>
              </Grid>
            </Grid>
            <Grid container item xs={12} lg={11}>
              <FieldArray
                name={"weeklyimage"}
                render={() =>
                  formik.values?.weeklyimage?.map((category, index) => {
                    return (
                      <WeeklyCategoryImageForm
                        formik={formik}
                        index={index}
                        key={`menuimage${index}`}
                      />
                    )
                  })
                }
              />
            </Grid>
          </>
        )}
      </Formik>
    </Fragment>
  )
}

export default EditWeeklyCategoryImage
